import {Component, Input} from '@angular/core';

@Component({
    selector: 'vui-select-input-option',
    templateUrl: './select-input-option.component.html',
    styleUrls: ['./select-input-option.component.scss']
})
export class SelectInputOptionComponent {
    @Input() public label: string;
    @Input() public value: any;

    constructor() {
    }
}
